class TestimonialSlider extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.testimonial-track');
    this.dots = this.querySelectorAll('.testimonial-dot');
    this.slides = this.querySelectorAll('.testimonial-slide');
    this.prevBtn = this.querySelector('.testimonial-nav-btn.prev');
    this.nextBtn = this.querySelector('.testimonial-nav-btn.next');
    
    this.currentIndex = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = parseInt(this.dataset.speed) || 5000;
    this.timer = null;

    if (!this.track || this.slides.length <= 1) return;

    this.bindEvents();
    
    if (this.autoplay) {
      this.startTimer();
    }
  }

  bindEvents() {
    // Pagination dots
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goToSlide(index);
        this.resetTimer();
      });
    });

    // Arrow buttons
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goToSlide(this.currentIndex - 1 < 0 ? this.slides.length - 1 : this.currentIndex - 1);
        this.resetTimer();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goToSlide((this.currentIndex + 1) % this.slides.length);
        this.resetTimer();
      });
    }

    // Pause timer on hover for better UX
    this.addEventListener('mouseenter', () => this.stopTimer());
    this.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startTimer();
    });

    // Shopify Theme Editor interop
    if (Shopify.designMode) {
      this.addEventListener('shopify:block:select', (event) => {
        const index = Array.from(this.slides).findIndex(
          (slide) => slide.dataset.blockId === event.detail.blockId
        );
        if (index !== -1) {
          this.goToSlide(index);
          this.stopTimer(); // Halt timer when actively editing a block
        }
      });
      this.addEventListener('shopify:block:deselect', () => {
        if (this.autoplay) this.startTimer();
      });
    }
  }

  goToSlide(index) {
    this.currentIndex = index;
    const translateX = -(index * 100);
    this.track.style.transform = `translateX(${translateX}%)`;

    // Update active dot
    this.dots.forEach(dot => dot.classList.remove('active'));
    if (this.dots[index]) {
      this.dots[index].classList.add('active');
    }
  }

  startTimer() {
    this.stopTimer(); // Clear any existing intervals first
    this.timer = setInterval(() => {
      this.goToSlide((this.currentIndex + 1) % this.slides.length);
    }, this.speed);
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  resetTimer() {
    if (this.autoplay) {
      this.startTimer();
    }
  }
}

if (!customElements.get('testimonial-slider')) {
  customElements.define('testimonial-slider', TestimonialSlider);
}